import React, { Component } from 'react';
import {
    Container,
    Row, Col
} from 'reactstrap';

import 'bootstrap/dist/css/bootstrap.css';
import "react-table/react-table.css";
import "./Reports.css";
import PermissionWrapper from '../../auth/PermissionWrapper';
import CompanyContext from '../../auth/CompanyContext';

class CRMCustomReports extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);
        this.state = {
        };

    }

    componentDidMount = () => {
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    render() {
        return (
            <PermissionWrapper {...this.props} allowedPermission="Reports">
                <Container fluid className='p-9'>
                    <PermissionWrapper {...this.props} allowedPermission="Show Secondary Ribbon" hidden={true}>
                        <Row>
                            <Col md={12} className='text-center'>
                                <h1>Custom CRM Reports</h1>
                            </Col>
                        </Row>
                    </PermissionWrapper>
                </Container>
            </PermissionWrapper>
        );
    }
}

export default CRMCustomReports;
